import ListToolbar from "../../../common/ListToolbar";

export default function SuppliersToolbar({ searchValue, onSearchChange, onAddClick }) {
  return (
    <ListToolbar
      title="Suppliers"
      subtitle="Manage the suppliers your organization purchases from."
      searchValue={searchValue}
      onSearchChange={onSearchChange}
      searchPlaceholder="Search suppliers…"
      addLabel="Add Supplier"
      onAddClick={onAddClick}
    />
  );
}